import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useData } from "../../context/DataContext";
import NumberFormat from "react-number-format";
import TextField from "@material-ui/core/TextField";
import { Button } from "@material-ui/core";

const NumberFormatCustom=({ inputRef, ...props })=> 
    <NumberFormat {...props}
      getInputRef={inputRef} thousandSeparator isNumericString prefix="$"/>
const NumberFormatSuffix=({ inputRef, ...props })=> 
    <NumberFormat {...props}
      getInputRef={inputRef} maxLength={4} thousandSeparator isNumericString suffix="%"/>

const Add = () => {
  const { goBack } = useHistory();
  const { id } = useParams();
  const [loading, setloading] = useState(false);
  const [error, seterror] = useState(false);
  const [product, setproduct] = useState(false);
  const data = useData();
  useEffect(() => {
    if (id) {
      const product = JSON.parse(JSON.stringify(data.tables.find((el) => el.id === id)));
      if (product) {
        product.strike = (product.strike || "").split("$")[1]
        product.executed_price = (product.executed_price || "").split("$")[1]
        product.spot_price = (product.spot_price || "").split("$")[1]
        product.formatted_premium = (product.formatted_premium || "").split("$")[1]
        product.implied_volatility = (product.implied_volatility || "").split("%")[0]
        product.expire_date = (product.expire_date || "").split("/").join("");
        setproduct(product)
      } else {
        seterror({
          message: `Product Must be deleted or not available in the database`,
        });
      }
    }
  }, [data.tables, id]);
  const handleChange = (event) => {
    setproduct({
      ...product,
      [event.target.name]: event.target.value,
    });
  };
  const onSubmit = (e) => {
    e.preventDefault();
    product.time = Date.now()
    setloading(true);
    if (id) {
      data.updateData(
        "tables",
        id,
        product,
        () => {
          goBack();
          setloading(false);
        },
        (err) => seterror(err)
      );
    } else {
      data.addData(
        "tables",
        product,
        () => {
          goBack();
          setloading(false);
        },
        (err) => seterror(err)
      );
    }
  };
  return (
    <div className="d-flex justify-content-center align-items-center py-5">
      <div className="container">
        <form
          onSubmit={onSubmit}
          className="row form bg-white shadow mx-auto"
          style={{ width: `450px`, minWidth: 250 }}
        >
          <h3 style={{fontFamily: "Montserrat"}} className="font-weight-bold w-100 text-center">Table Schema</h3>
          <div className="w-100"></div>
          <div className="col-sm-6 text-capitalize py-2">
            <TextField
              value={product.ticker}
              onChange={handleChange}
              name="ticker"
              required
              id="ticker"
              label="Ticker"
              type="text"
            />
          </div>
          <div className="col-sm-6 text-capitalize py-2">
            <TextField
              value={product.strike}
              onChange={handleChange}
              name="strike"
              required
              id="strike"
              label="Strike"
              InputProps={{ inputComponent: NumberFormatCustom }}
              type="text"
            />
          </div>
          <div className="col-sm-6 text-capitalize py-2">
            <TextField
              value={product.executed_price}
              onChange={handleChange}
              name="executed_price"
              required
              id="executed_price"
              label="executed price"
              type="text"
              InputProps={{ inputComponent: NumberFormatCustom }}
              />
          </div>
          <div className="col-sm-6 text-capitalize py-2">
            <TextField
              value={product.order_type}
              onChange={handleChange}
              name="order_type"
              required
              id="order_type"
              label="order type"
              type="text"
            />
          </div>
          <div className="col-sm-6 text-capitalize py-2">
            <TextField
              value={product.expire_date}
              onChange={handleChange}
              name="expire_date"
              required
              id="expire_date"
              label="expire date"
              type="date"
            />
          </div>
          <div className="col-sm-6 text-capitalize py-2">
            <TextField
              value={product.order_num}
              onChange={handleChange}
              name="order_num"
              required
              id="order_num"
              label="order num"
              type="text"
            />
          </div>
          <div className="col-sm-6 text-capitalize py-2">
            <TextField
              value={product.spot_price}
              onChange={handleChange}
              name="spot_price"
              required
              id="spot_price"
              label="spot price"
              type="text"
              InputProps={{ inputComponent: NumberFormatCustom }}
            />
          </div>
          <div className="col-sm-6 text-capitalize py-2">
            <TextField
              value={product.premium}
              onChange={handleChange}
              name="premium"
              required
              id="premium"
              label="premium"
              type="text"
            />
          </div>
          <div className="col-sm-6 text-capitalize py-2">
            <TextField
              label="Formatted Premium"
              value={product.formatted_premium}
              onChange={handleChange}
              name="formatted_premium"
              required
              id="formatted_premium"
              InputProps={{ inputComponent: NumberFormatCustom }}
            />
          </div>
          <div className="col-sm-6 text-capitalize py-2">
            <TextField
              value={product.implied_volatility}
              onChange={handleChange}
              name="implied_volatility"
              required
              id="implied_volatility"
              label="implied volatility"
              type="text"
              InputProps={{ inputComponent: NumberFormatSuffix }}
            />
          </div>
          <div className="col-sm-6 text-capitalize py-2">
            <TextField
              value={product.delta}
              onChange={handleChange}
              name="delta"
              required
              id="delta"
              label="delta"
              type="text"
            />
          </div>
          <div className="col-sm-6 text-capitalize py-2">
            <TextField
              value={product.initial_order}
              onChange={handleChange}
              name="initial_order"
              required
              id="initial_order"
              label="initial order"
              type="text"
            />
          </div>
          <div className="col-sm-6 text-capitalize py-2">
            <TextField
              value={product.notes}
              onChange={handleChange}
              name="notes"
              required
              id="notes"
              label="notes"
              type="text"
            />
          </div>
          <div className="col-sm-12 text-center mt-3">
            <Button type="submit" style={{fontFamily: "Montserrat"}} className="px-4 py-2 h3" disabled={loading} variant="contained">Submit</Button>
          </div>
          {error ? (
            <div className="alert font_small alert-danger">{error.message}</div>
          ) : (
            ""
          )}
        </form>
      </div>
    </div>
  );
};

export default Add;
